module.exports = __webpack_public_path__ + "vu.af25c20f3f9c0761f3f8.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/vu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/vu.svg
// module chunks = styles